// routes/_app.model.tags.($tag).tsx
// Legacy route - outputs same OG meta as /tags/model/:tag, redirects on client
import type { ClientLoaderFunctionArgs } from 'react-router'
import { redirect } from 'react-router'
import { tagMeta, tagMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.model.tags.($tag)'

export const handle = { name: 'model/tags' }

export async function loader({ params, request }: Route.LoaderArgs) {
  const { fetchTagForSSR } =
    await import('src/utils/ssr-meta/graphql/tag.server')

  const tag = params.tag ? await fetchTagForSSR(params.tag) : null
  return tagMetaLoader({
    type: 'model',
    tagSlug: params.tag,
    tag,
    requestUrl: request.url,
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return tagMeta(loaderData)
}

export async function clientLoader({
  request,
  params,
}: ClientLoaderFunctionArgs) {
  if (!params.tag) {
    return redirect('/')
  }
  const { track } = await import('src/utils/tracker')
  track('legacy_route', { pathname: '/model/tags/*' })
  const url = new URL(request.url)
  url.pathname = url.pathname.replace(/\/model\/tags\//, '/tags/model/')
  return redirect(url.href)
}
clientLoader.hydrate = true

export default function Page() {
  return null
}
